import React, { useEffect } from 'react';
import { TableCell } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';

function Processos({
  etapas,
  status,
  setStatus,
  encerramento,
  setEncerramento,
  observacao,
  setObservacao,
  observacao_interna,
  setObservacaoInterna,
}) {
  useEffect(() => {
    if (!status) {
      setStatus('NAO INICIADO');
    }
  }, [setStatus, status]);

  const options = [
    {
      value: 'EM ANDAMENTO',
      label: 'Em Andamento',
    },
    {
      value: 'CONCLUIDO',
      label: 'Concluído',
    },
    {
      value: 'NAO INICIADO',
      label: 'Não Iniciado',
    },
  ];

  return (
    <>
      <TableCell align="right">
        <Grid container direction="row" justify="center" alignItems="center">
          <Typography variant="body1" gutterBottom>
            {etapas}
          </Typography>
        </Grid>
      </TableCell>
      <TableCell align="right">
        <TextField
          style={{ width: '100%', textAlign: 'center' }}
          id="outlined-basic"
          variant="outlined"
          value={status || 'NAO INICIADO'}
          size="small"
          color="primary"
          select
          onChange={(e) => setStatus(e.target.value)}
        >
          {options.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </TextField>
      </TableCell>
      <TableCell align="right">
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBrLocale}>
          <KeyboardDatePicker
            margin="normal"
            id="picker-inicio"
            label="Data"
            format="dd/MM/yyyy"
            value={encerramento || null}
            onChange={(data) => {
              const dt = moment(data).format('YYYY-MM-DD HH:ss');
              setEncerramento(dt);
            }}
            KeyboardButtonProps={{
              'aria-label': 'Mudar Data',
            }}
          />
        </MuiPickersUtilsProvider>
      </TableCell>
      <TableCell align="right">
        <TextField
          style={{ width: '100%' }}
          id="observacao"
          variant="outlined"
          value={observacao}
          size="small"
          color="primary"
          onChange={(e) => setObservacao(e.target.value)}
          multiline
          rows={2}
        />
      </TableCell>
      <TableCell align="right">
        <TextField
          style={{ width: '100%' }}
          id="observacao"
          variant="outlined"
          value={observacao_interna}
          size="small"
          color="primary"
          onChange={(e) => setObservacaoInterna(e.target.value)}
          multiline
          rows={2}
        />
      </TableCell>
    </>
  );
}

export default Processos;
